"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCheckOutEnd = exports.getCheckInEnd = exports.getCheckInStart = exports.buildCawData = exports.getCawData = void 0;
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const helpers_1 = require("../helpers");
const cawDefaults = Object.assign(Object.assign({}, helpers_1.employeeConfig), { minStay: 1, maxStay: 28, maxRooms: 4, maxRoomsPP: 4, defaultAdults: 2, defaultChildren: 0, minAdults: 1, minChildren: 0, maxAdults: 9, maxChildren: 9, maxAdvancedBookingDays: 364 });
const openingDateFormat = 'MM/DD/YY';
const calendarAvailabilityTimeZone = 'America/New_York';
const getCawData = (input) => {
    try {
        if (!input) {
            throw new helpers_1.ContentError('Invalid parameters - input required');
        }
        if (!input.content) {
            throw new helpers_1.ContentError('Invalid parameters - content required');
        }
        const cawData = buildCawData(input);
        return { caw: cawData };
    }
    catch (err) {
        if (err instanceof helpers_1.ContentError) {
            return { error: err };
        }
        throw err;
    }
};
exports.getCawData = getCawData;
const buildCawData = (cawInput, propertyInput) => {
    var _a, _b;
    const { globalSettings, regions: regionsInput, status, calendarAvailability, employeeCalendarAvailability, } = cawInput.content;
    if (!regionsInput) {
        throw new helpers_1.ContentError('Invalid parameters - content.regions required');
    }
    if (!status) {
        throw new helpers_1.ContentError('Invalid parameters - content.status required');
    }
    if (!globalSettings) {
        throw new helpers_1.ContentError('Invalid parameters - content.globalSettings required');
    }
    const customizations = cawInput.customizations || {};
    const defaultAdults = parseInt(globalSettings.defaultAdults, 10) || cawDefaults.defaultAdults;
    const defaultChildren = globalSettings.defaultChildren
        ? parseInt(globalSettings.defaultChildren, 10) || cawDefaults.defaultChildren
        : cawDefaults.defaultChildren;
    const defaultMaxAdults = globalSettings.defaultMaxAdults
        ? parseInt(globalSettings.defaultMaxAdults, 10) || cawDefaults.maxAdults
        : cawDefaults.maxAdults;
    const defaultMaxChildren = globalSettings.defaultMaxChildren
        ? parseInt(globalSettings.defaultMaxChildren, 10) || cawDefaults.maxChildren
        : cawDefaults.maxChildren;
    const defaultMaxBodies = defaultMaxAdults + defaultMaxChildren;
    const defaultMinStay = globalSettings.minNights
        ? parseInt(globalSettings.minNights, 10) || cawDefaults.minStay
        : cawDefaults.minStay;
    const defaultMaxStay = globalSettings.maxNights
        ? parseInt(globalSettings.maxNights, 10) || cawDefaults.maxStay
        : cawDefaults.maxStay;
    let { employeeMaxStay } = cawDefaults;
    const employeeRate = !!cawInput.employee &&
        cawDefaults.employeeRates.find(empRate => {
            var _a;
            return (!!((_a = cawInput.cawState) === null || _a === void 0 ? void 0 : _a.promoCode) && !!empRate.code.exec(cawInput.cawState.promoCode));
        });
    employeeMaxStay = employeeRate ? employeeRate.maxStay : employeeMaxStay;
    let { employeeRequestMaxAdults, employeeRequestMaxChildren, employeeRequestMaxTotal, } = cawDefaults;
    const { employeeRequestMaxRooms } = cawDefaults;
    if (!!employeeRate && !employeeRate.bookable) {
        employeeRequestMaxAdults = globalSettings.employee_booking_default_adults_max
            ? parseInt(globalSettings.employee_booking_default_adults_max, 10) ||
                employeeRequestMaxAdults
            : employeeRequestMaxAdults;
        employeeRequestMaxChildren = globalSettings.employee_booking_default_children_max
            ? parseInt(globalSettings.employee_booking_default_children_max, 10) ||
                employeeRequestMaxChildren
            : employeeRequestMaxChildren;
        employeeRequestMaxTotal = employeeRequestMaxAdults + employeeRequestMaxChildren;
    }
    let defaultMaxRooms = globalSettings.maxRooms
        ? parseInt(globalSettings.maxRooms, 10) || cawDefaults.maxRooms
        : cawDefaults.maxRooms;
    if (cawInput.pp) {
        defaultMaxRooms = globalSettings.maxRoomsPP
            ? parseInt(globalSettings.maxRoomsPP, 10) || cawDefaults.maxRoomsPP
            : cawDefaults.maxRoomsPP;
    }
    const minAdults = customizations.minAdults || cawDefaults.minAdults;
    const minChildren = customizations.minChildren || cawDefaults.minChildren;
    const promoHide = cawInput.pp ? true : !!customizations.promoHide;
    let promoDisabled = !!customizations.promoDisabled;
    let cawConfig;
    const regions = regionsInput.regions.reduce((regionsReturn, region) => {
        const properties = region.properties.reduce((returnProperties, property) => {
            var _a, _b, _c, _d, _e, _f, _g;
            if (customizations.propertyList &&
                customizations.propertyList.length &&
                !customizations.propertyList.includes(property.owsCode || '')) {
                return returnProperties;
            }
            returnProperties.push({
                name: helpers_1.formatBeverlyWilshire(property.shortName || ''),
                code: property.owsCode || '',
            });
            if (!((_a = cawInput.cawState) === null || _a === void 0 ? void 0 : _a.hotelCode) || property.owsCode !== cawInput.cawState.hotelCode) {
                return returnProperties;
            }
            const defaultProperty = (propertyInput === null || propertyInput === void 0 ? void 0 : propertyInput.metadata.owsCode) === property.owsCode ? property : null;
            let propertyMinStay = property.minNights ? parseInt(property.minNights, 10) || 0 : 0;
            propertyMinStay = Math.max(propertyMinStay, customizations.minStay || propertyMinStay);
            let propertyMaxStay = property.maxNights ? parseInt(property.maxNights, 10) || 0 : 0;
            if (cawInput.employee && (!propertyMaxStay || employeeMaxStay < propertyMaxStay)) {
                propertyMaxStay = employeeMaxStay;
            }
            let offerAdvanced = 0;
            if (!!defaultProperty && !!(propertyInput === null || propertyInput === void 0 ? void 0 : propertyInput.offer)) {
                if (propertyInput.offer.minStay) {
                    propertyMinStay = Math.max(propertyMinStay, parseInt(propertyInput.offer.minStay, 10) || propertyMinStay);
                }
                if (propertyInput.offer.maxStay) {
                    const offerMaxStay = parseInt(propertyInput.offer.maxStay, 10) || propertyMaxStay;
                    if (offerMaxStay && (!propertyMaxStay || offerMaxStay < propertyMaxStay)) {
                        propertyMaxStay = offerMaxStay;
                    }
                }
                if (propertyInput.offer.advancePurchase) {
                    offerAdvanced =
                        parseInt(propertyInput.offer.advancePurchase, 10) || offerAdvanced;
                }
            }
            if (!propertyMinStay) {
                propertyMinStay = defaultMinStay;
            }
            if (!propertyMaxStay) {
                propertyMaxStay = defaultMaxStay;
            }
            const propertyCheckInStart = getCheckInStart(offerAdvanced, property.timeZone, property.openingDate, customizations.checkInStart, employeeRate ? (_b = cawInput.employee) === null || _b === void 0 ? void 0 : _b.checkInStart : undefined);
            const propertyCheckOutEnd = getCheckOutEnd(property.timeZone, propertyMaxStay, customizations.checkOutEnd, (_c = cawInput.cawState) === null || _c === void 0 ? void 0 : _c.checkInDate);
            const propertyCheckInEnd = getCheckInEnd(propertyMinStay, property.timeZone, customizations.checkInEnd, !!employeeRate);
            const cawCalendar = {
                checkInStart: propertyCheckInStart,
                checkInEnd: propertyCheckInEnd,
                checkOutEnd: propertyCheckOutEnd,
                availabilityEnabled: false,
                restrictions: {
                    minStay: propertyMinStay,
                    maxStay: propertyMaxStay,
                },
            };
            let employeeMaxAdults;
            let employeeMaxChildren;
            let employeeMaxTotal;
            if (customizations.calendarAvailabilityEnabled !== false) {
                if (cawInput.employee) {
                    const employeePropertyCA = employeeCalendarAvailability &&
                        employeeCalendarAvailability[property.owsCode || ''];
                    const rateAvailability = !!employeeRate &&
                        ((!!employeeRate.code.exec('EMPCMP') && (employeePropertyCA === null || employeePropertyCA === void 0 ? void 0 : employeePropertyCA.EMPCMP)) ||
                            (!!employeeRate.code.exec('EMPECE') && (employeePropertyCA === null || employeePropertyCA === void 0 ? void 0 : employeePropertyCA.EMPECE)));
                    if (rateAvailability) {
                        cawCalendar.availabilityEnabled = true;
                        if (employeePropertyCA === null || employeePropertyCA === void 0 ? void 0 : employeePropertyCA.maxOccupancy) {
                            employeeMaxAdults = employeePropertyCA.maxOccupancy.adults;
                            employeeMaxChildren = employeePropertyCA.maxOccupancy.children;
                            employeeMaxTotal = employeePropertyCA.maxOccupancy.total;
                        }
                        cawCalendar.unavailableDates = rateAvailability.noAvailabilityDates
                            .concat(rateAvailability.restrictedDates)
                            .sort()
                            .map(day => {
                            return new Date(moment_timezone_1.default(moment_timezone_1.default
                                .tz(day, calendarAvailabilityTimeZone)
                                .format('YYYY-MM-DDTHH:mm:ss')).valueOf());
                        });
                        if (rateAvailability.cached) {
                            cawCalendar.availabilityLastUpdated = new Date(rateAvailability.cached);
                        }
                    }
                }
                else {
                    const propertyCA = calendarAvailability && calendarAvailability[property.owsCode || ''];
                    if (propertyCA && propertyCA.length) {
                        cawCalendar.availabilityEnabled = true;
                        const calendarDates = propertyCA.reduce((returnDates, monthData) => {
                            var _a, _b;
                            const unavailableDates = (_a = returnDates.unavailableDates) === null || _a === void 0 ? void 0 : _a.concat(monthData.noAvailabilityDates.map(day => {
                                return new Date(moment_timezone_1.default(moment_timezone_1.default
                                    .tz(day, calendarAvailabilityTimeZone)
                                    .format('YYYY-MM-DDTHH:mm:ss')).valueOf());
                            }));
                            const restrictedDates = (_b = returnDates.restrictedDates) === null || _b === void 0 ? void 0 : _b.concat(monthData.restrictedDates.map(day => {
                                return new Date(moment_timezone_1.default(moment_timezone_1.default
                                    .tz(day, calendarAvailabilityTimeZone)
                                    .format('YYYY-MM-DDTHH:mm:ss')).valueOf());
                            }));
                            return { unavailableDates, restrictedDates };
                        }, {
                            unavailableDates: [],
                            restrictedDates: [],
                        });
                        cawCalendar.unavailableDates = calendarDates.unavailableDates;
                        cawCalendar.restrictedDates = calendarDates.restrictedDates;
                        if (propertyCA[0].cached) {
                            cawCalendar.availabilityLastUpdated = new Date(propertyCA[0].cached);
                        }
                    }
                }
            }
            const propertyDefaultAdults = customizations.defaultAdults ||
                (property.defaultAdults
                    ? parseInt(property.defaultAdults, 10) || defaultAdults
                    : defaultAdults);
            let propertyDefaultChildren = defaultChildren;
            if (!!customizations.defaultChildren || customizations.defaultChildren === 0) {
                propertyDefaultChildren = customizations.defaultChildren;
            }
            else {
                propertyDefaultChildren = property.defaultChildren
                    ? parseInt(property.defaultChildren, 10) || defaultChildren
                    : defaultChildren;
            }
            let propertyMaxRooms = 0;
            if (cawInput.pp && property.maxRoomsPP) {
                propertyMaxRooms = parseInt(property.maxRoomsPP, 10) || propertyMaxRooms;
            }
            else if (!cawInput.pp && property.maxRooms) {
                propertyMaxRooms = parseInt(property.maxRooms, 10) || propertyMaxRooms;
            }
            if (!!cawInput.employee &&
                (!propertyMaxRooms || cawDefaults.employeeMaxRooms < propertyMaxRooms)) {
                propertyMaxRooms = cawDefaults.employeeMaxRooms;
            }
            if (customizations.maxRooms &&
                (!propertyMaxRooms || customizations.maxRooms < propertyMaxRooms)) {
                propertyMaxRooms = customizations.maxRooms;
            }
            if (!propertyMaxRooms) {
                propertyMaxRooms = defaultMaxRooms;
            }
            let propertyMaxAdults = property.maxAdultOccupancy || 0;
            if (customizations.maxAdults &&
                (!propertyMaxAdults || customizations.maxAdults < propertyMaxAdults)) {
                propertyMaxAdults = customizations.maxAdults;
            }
            if (!propertyMaxAdults) {
                propertyMaxAdults = defaultMaxAdults;
            }
            if (employeeMaxAdults && employeeMaxAdults < propertyMaxAdults) {
                propertyMaxAdults = employeeMaxAdults;
            }
            let propertyMaxChildren = 0;
            if (!!property.maxChildOccupancy || property.maxChildOccupancy === 0) {
                if (!!customizations.maxChildren || customizations.maxChildren === 0) {
                    propertyMaxChildren = Math.min(property.maxChildOccupancy, customizations.maxChildren);
                }
                else {
                    propertyMaxChildren = property.maxChildOccupancy;
                }
            }
            else if (!!customizations.maxChildren || customizations.maxChildren === 0) {
                propertyMaxChildren = customizations.maxChildren;
            }
            else {
                propertyMaxChildren = defaultMaxChildren;
            }
            if ((employeeMaxChildren || employeeMaxChildren === 0) &&
                employeeMaxChildren < propertyMaxChildren) {
                propertyMaxChildren = employeeMaxChildren;
            }
            let propertyMaxBodies = propertyMaxAdults + propertyMaxChildren;
            propertyMaxBodies = Math.min(propertyMaxBodies, property.maxNumberOfBodies || propertyMaxBodies, customizations.maxBodies || propertyMaxBodies);
            if (employeeMaxTotal && employeeMaxTotal < propertyMaxBodies) {
                propertyMaxBodies = employeeMaxTotal;
            }
            if (!!employeeRate && !employeeRate.bookable) {
                propertyMaxAdults = employeeRequestMaxAdults;
                propertyMaxChildren = employeeRequestMaxChildren;
                propertyMaxBodies = employeeRequestMaxTotal;
                propertyMaxRooms = employeeRequestMaxRooms;
            }
            const disableFlexDates = !property.flexDates ||
                !!property.disableFlexDates ||
                !!cawInput.employee ||
                !!cawInput.pp ||
                (!!((_d = cawInput.cawState) === null || _d === void 0 ? void 0 : _d.promoCode) && !((_e = cawInput.cawState) === null || _e === void 0 ? void 0 : _e.flexDatesWindow));
            if (!disableFlexDates &&
                !((_f = cawInput.cawState) === null || _f === void 0 ? void 0 : _f.promoCode) &&
                !!((_g = cawInput.cawState) === null || _g === void 0 ? void 0 : _g.flexDatesWindow)) {
                promoDisabled = true;
            }
            const thisProperty = {
                name: helpers_1.formatBeverlyWilshire(property.shortName || ''),
                code: property.owsCode || '',
                timezone: property.timeZone || '',
                disableFlexDates,
                flexDates: disableFlexDates ? undefined : property.flexDates,
                calendar: cawCalendar,
                fields: {
                    maxRooms: propertyMaxRooms,
                    promoHide,
                    promoDisabled,
                    defaultAdults: propertyDefaultAdults,
                    defaultChildren: propertyDefaultChildren,
                    minAdults,
                    minChildren,
                    maxAdults: propertyMaxAdults,
                    maxChildren: propertyMaxChildren,
                    maxBodies: propertyMaxBodies,
                    minChildAge: property.minChildAge
                        ? parseInt(property.minChildAge, 10)
                        : undefined,
                    maxChildAge: property.maxChildAge
                        ? parseInt(property.maxChildAge, 10)
                        : undefined,
                },
            };
            const propertyStatus = status[property.owsCode || ''];
            if (propertyStatus) {
                thisProperty.offline = {
                    title: propertyStatus.title || '',
                    explanation: propertyStatus.explanation || '',
                    phone: propertyStatus.phone,
                    email: propertyStatus.email,
                };
                if (!propertyStatus.buttonSuppress &&
                    propertyStatus.buttonText &&
                    propertyStatus.buttonLink) {
                    thisProperty.offline.button = {
                        url: propertyStatus.buttonLink,
                        text: propertyStatus.buttonText,
                    };
                }
            }
            if (property.propertyPhone) {
                thisProperty.phone = {
                    number: property.propertyPhone,
                };
            }
            if (property.globalTollFreeLink) {
                thisProperty.globalTollFreeLink = {
                    url: property.globalTollFreeLink,
                    textDictKey: helpers_1.setDictionaryKey('Toll Free Telephone Numbers By Country'),
                };
            }
            cawConfig = Object.assign({}, thisProperty);
            return returnProperties;
        }, []);
        if (properties.length) {
            regionsReturn.push({
                title: region.title,
                properties,
            });
        }
        return regionsReturn;
    }, []);
    if (!cawConfig) {
        const maxStay = cawInput.employee ? employeeMaxStay : defaultMaxStay;
        const defaultCheckInStart = getCheckInStart(0, '', '', customizations.checkInStart, employeeRate ? (_a = cawInput.employee) === null || _a === void 0 ? void 0 : _a.checkInStart : undefined);
        const defaultCheckOutEnd = getCheckOutEnd('', maxStay, customizations.checkOutEnd, (_b = cawInput.cawState) === null || _b === void 0 ? void 0 : _b.checkInDate);
        const defaultCheckInEnd = getCheckInEnd(customizations.minStay || defaultMinStay, '', customizations.checkInEnd, !!employeeRate);
        let maxRooms = cawInput.employee ? cawDefaults.employeeMaxRooms : 0;
        if (customizations.maxRooms && (!maxRooms || customizations.maxRooms < maxRooms)) {
            maxRooms = customizations.maxRooms;
        }
        if (!maxRooms) {
            maxRooms = defaultMaxRooms;
        }
        let maxAdults = customizations.maxAdults || defaultMaxAdults;
        let maxChildren = !!customizations.maxChildren || customizations.maxChildren === 0
            ? customizations.maxChildren
            : defaultMaxChildren;
        let maxBodies = customizations.maxBodies || maxAdults + maxChildren;
        if (!!employeeRate && !employeeRate.bookable) {
            maxAdults = employeeRequestMaxAdults;
            maxChildren = employeeRequestMaxChildren;
            maxBodies = employeeRequestMaxTotal;
            maxRooms = employeeRequestMaxRooms;
        }
        cawConfig = {
            name: 'Find a Destination',
            code: '',
            timezone: '',
            calendar: {
                checkInStart: defaultCheckInStart,
                checkInEnd: defaultCheckInEnd,
                checkOutEnd: defaultCheckOutEnd,
                availabilityEnabled: false,
                restrictions: {
                    minStay: customizations.minStay || defaultMinStay,
                    maxStay,
                },
            },
            disableFlexDates: true,
            fields: {
                maxRooms,
                promoHide,
                promoDisabled,
                defaultAdults: customizations.defaultAdults || defaultAdults,
                defaultChildren: !!customizations.defaultChildren || customizations.defaultChildren === 0
                    ? customizations.defaultChildren
                    : defaultChildren,
                minAdults,
                minChildren,
                maxAdults,
                maxChildren,
                maxBodies,
            },
        };
    }
    const cawData = {
        pp: !!cawInput.pp,
        embedded: !!cawInput.embedded,
        regions,
        cawConfig,
    };
    if (cawInput.employee) {
        if (!employeeRate || employeeRate.bookable) {
            if (globalSettings.employee_booking_caw_messages) {
                cawData.message = {
                    title: globalSettings.employee_booking_caw_messages.title || '',
                    message: globalSettings.employee_booking_caw_messages.bullet_messages || [],
                };
            }
        }
        else {
            cawData.message = {
                title: helpers_1.setDictionaryKey('Terms & Conditions'),
                message: globalSettings.employee_booking_terms_and_conditions || [],
            };
        }
    }
    return cawData;
};
exports.buildCawData = buildCawData;
const getCheckInStart = (offerAdvanced, propertyTimezone = '', openingDate, customStart, employeeStart) => {
    const timezone = propertyTimezone || moment_timezone_1.default.tz.guess();
    let checkInStart = moment_timezone_1.default.tz(timezone);
    let dateCompare = checkInStart.clone();
    if (openingDate) {
        dateCompare = moment_timezone_1.default.tz(openingDate, openingDateFormat, timezone);
        if (dateCompare.isAfter(checkInStart)) {
            checkInStart = dateCompare.clone();
        }
    }
    if (offerAdvanced > 0) {
        dateCompare = moment_timezone_1.default.tz(timezone).add(offerAdvanced, 'days');
        if (dateCompare.isAfter(checkInStart)) {
            checkInStart = dateCompare.clone();
        }
    }
    if (customStart) {
        dateCompare = moment_timezone_1.default.tz(customStart, 'UTC');
        dateCompare = moment_timezone_1.default.tz(dateCompare.format('YYYY-MM-DD'), timezone);
        if (dateCompare.isAfter(checkInStart)) {
            checkInStart = dateCompare.clone();
        }
    }
    if (employeeStart) {
        dateCompare = moment_timezone_1.default.tz(employeeStart, 'UTC');
        dateCompare = moment_timezone_1.default.tz(dateCompare.format('YYYY-MM-DD'), timezone);
        if (dateCompare.isAfter(checkInStart)) {
            checkInStart = dateCompare.clone();
        }
    }
    return new Date(moment_timezone_1.default(checkInStart.format('YYYY-MM-DDTHH:mm:ss')).valueOf());
};
exports.getCheckInStart = getCheckInStart;
const getCheckOutEnd = (propertyTimezone = '', maxStay, customEnd, checkInDate) => {
    const timezone = propertyTimezone || moment_timezone_1.default.tz.guess();
    let checkOutEnd = moment_timezone_1.default.tz(timezone).add(cawDefaults.maxAdvancedBookingDays, 'days');
    let dateCompare = checkOutEnd.clone();
    if (customEnd) {
        dateCompare = moment_timezone_1.default.tz(customEnd, 'UTC');
        dateCompare = moment_timezone_1.default.tz(dateCompare.format('YYYY-MM-DD'), timezone);
        if (dateCompare.isBefore(checkOutEnd)) {
            checkOutEnd = dateCompare.clone();
        }
    }
    if (checkInDate) {
        dateCompare = moment_timezone_1.default.tz(checkInDate, 'UTC');
        dateCompare = moment_timezone_1.default
            .tz(dateCompare.format('YYYY-MM-DD'), timezone)
            .add(maxStay, 'days');
        if (dateCompare.isBefore(checkOutEnd)) {
            checkOutEnd = dateCompare.clone();
        }
    }
    return new Date(moment_timezone_1.default(checkOutEnd.format('YYYY-MM-DDTHH:mm:ss')).valueOf());
};
exports.getCheckOutEnd = getCheckOutEnd;
const getCheckInEnd = (minStay, propertyTimezone = '', customEnd, employee) => {
    const timezone = propertyTimezone || moment_timezone_1.default.tz.guess();
    let checkInEnd = moment_timezone_1.default
        .tz(timezone)
        .add(cawDefaults.maxAdvancedBookingDays - minStay, 'days');
    let dateCompare = checkInEnd.clone();
    if (employee) {
        dateCompare = moment_timezone_1.default.tz(timezone).add(cawDefaults.employeeCheckInDays - 1, 'days');
        if (dateCompare.isBefore(checkInEnd)) {
            checkInEnd = dateCompare.clone();
        }
    }
    if (customEnd) {
        dateCompare = moment_timezone_1.default.tz(customEnd, 'UTC');
        dateCompare = moment_timezone_1.default.tz(dateCompare.format('YYYY-MM-DD'), timezone);
        if (dateCompare.isBefore(checkInEnd)) {
            checkInEnd = dateCompare.clone();
        }
    }
    return new Date(moment_timezone_1.default(checkInEnd.format('YYYY-MM-DDTHH:mm:ss')).valueOf());
};
exports.getCheckInEnd = getCheckInEnd;
